/*
 * Formata valor para R$ com 2 casas decimais
 * Ex: 12.3 => 12,30
 */
export const currencyFormat = (value = 0, currency = '') => (
  `${currency}${Number(value).toFixed(2).replace('.', ',')}`
)

export const decimalFormat = (value = '') => (
  value.replace(',', '.')
)

export const onlyNumbers = (value = '') => (
  value.replace(/\D/g, '')
)

/*
 * Transforma valores digitados nos campos de R$
 * em decimal no formato 000.00
 * Ex: '123' => '1.23'
 */
export const decimalForInput = (value = '0') => {
  const number = onlyNumbers(value)
  return (Number(number) / 100).toFixed(2)
}

export const currencyForInput = (value = '0,00') => {
  const currency = onlyNumbers(`${value}`)
  return currencyFormat(Number(currency) / 100)
}

export const formatterMoney = (value = '') => (
  new Intl.NumberFormat(
    'pt-BR', {
      style: 'currency',
      currency: 'BRL',
    },
  ).format(value)
)

export const normalizeCurrencyString = (value = '0.0') => {
  const number = `${value}`.replace(',', '.')
  return Number(number).toFixed(2)
}

export const documentPreview = (doc) => {
  if (!doc) return ''

  const preview = doc.slice(0, 3)
  return preview.padEnd(8, '*')
}

export const postalCode = (code = '') => {
  if (!code) return ''

  const numbers = onlyNumbers(code)
  return numbers.replace(/(\d{5})(\d{3})/g, '$1-$2')
}

export const cpfCnpj = (value = '') => {
  if (!value) return ''

  if (value.length < 12) {
    const cpf = /(\d{3})(\d{3})(\d{3})(\d{2})/g
    return value.replace(cpf, '$1.$2.$3-$4')
  }

  const cnpj = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g
  return value.replace(cnpj, '$1.$2.$3/$4-$5')
}

export const simpleStrDate = (strDate) => {
  if (!strDate) return ''

  const date = onlyNumbers(strDate)
  return date.replace(/(\d{4})(\d{2})(\d{2})/g, '$3/$2/$1')
}

export const phoneNumber = (phone = '') => {
  if (phone.length < 11) {
    return phone.replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3')
  }

  return phone.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3')
}

export const qttInput = (qtt = '') => {
  let i = 0
  const number = qtt.replace(/[^0-9.]/g, '')

  return `${number}`.replace(/\./g, (match) => {
    i += 1
    return i > 1 ? '' : match
  })
}

export const codeFormat = (code = '') => (
  `${code}`.padStart(5, '0')
)

export const cupomQttFormat = (qtt = 0) => (
  Number(qtt).toFixed(3).replace('.', ',')
)
